module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAARJJREFUKBWFk0ESgjAMReEmrPRInkhX3AAuwTk8g+5w3HgAV/geNNCOODLzp+1PftIkpaqyb6qqGpzAAEbwTqtn+Tpz37YYGnAFE7iDHpxBB25AXnuzqdhJgCd4ga8McHEjb6LfEiAZjKjwUETNDthaYHYD6F+b1UySp8y32GILoevmz8FmWONuM+BXoRH1A/Zg8PAAfZEqHeALYfjA28RRsTWcwxAr3K5QO7aLusjchSgZfwqT3THOma3ZGuaaWf8JrdkezTWv3fsnTFlXf69tJOdm7Y6szUvI99iOwPewzDlFayB8OQYwcjE2z4lXuL2wiAxpACOa3R44Dt+2zbFGee1NaIoVQ2Swic7fm7ju/lUflpTW+1L0/DcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/answer-question/img/u31.png
// module id = kETa
// module chunks = 0